<template>
  <div class="content">
    <div class="top">
      <img class="title-pic" src="@/static/images/activityCenter/202404/02/30.png" />
    </div>
    <div class="list-content">
      <div class="head-box">
        <div class="item" :class="{ 'active': activeIndex == item.value }" v-for="(item, index) in tabList" :key="index" @click="clickTabs(item.value)">
          <span>{{ item.name }}</span>
          <div class="line" v-if="activeIndex == item.value"></div>
        </div>
      </div>
      <div class="statistics">
        <div class="statistics-box" v-if="activeIndex == 1">
          <div class="item">
            <span class="num"
              >{{ downloadNum }}
              <span class="unit">人</span>
            </span>
            <span class="text">好友注册并下载</span>
            <div class="line"></div>
          </div>
          <div class="item">
            <span class="num"
              >{{ rewardNum }}
              <span class="unit">元</span>
            </span>
            <span class="text">您的奖励</span>
          </div>
        </div>
        <div class="statistics-box" v-if="activeIndex == 2">
          <div class="item">
            <span class="num"
              >{{ downloadNum }}
              <span class="unit">人</span>
            </span>
            <span class="text">好友签约人数</span>
            <div class="line"></div>
          </div>
          <div class="item">
            <span class="num"
              >{{ rewardNum }}
              <span class="unit">元</span>
            </span>
            <span class="text">您的奖励</span>
          </div>
        </div>
        <div class="statistics-box" v-if="activeIndex == 3">
          <div class="item">
            <span class="num"
              >{{ statistics.foldFybSum || '0.00' }}
              <span class="unit">元</span>
            </span>
            <span class="text">好友出单标保</span>
            <div class="line"></div>
          </div>
          <div class="item">
            <span class="num"
              >{{ statistics.rewardPriceSum || '0.00' }}
              <span class="unit">元</span>
            </span>
            <span class="text">您的奖励</span>
          </div>
        </div>
      </div>

      <div class="list">
        <template v-if="activeIndex == 1">
          <div class="table-head-flex">
            <div class="item">姓名</div>
            <div class="item">手机号</div>
          </div>
          <div class="list-container" v-if="tableList.length">
            <div class="list-box" v-for="(item, index) in tableList" :key="index">
              <div class="item">{{ item.beRecommendedName }}</div>
              <div class="item">{{ item.beRecommendedMobile }}</div>
            </div>
            <div class="no-more" v-if="tableList.length">暂无更多</div>
          </div>
          <div class="no-data" v-else>
            <img class="title-pic" src="@/static/images/activityCenter/202404/02/29.png" />
            <span class="text">暂无数据</span>
          </div>
        </template>

        <template v-else-if="activeIndex == 2">
          <div class="table-head">
            <div class="item name name-right">姓名</div>
            <div class="item">手机号</div>
            <div class="item reward-detail">签约状态</div>
          </div>

          <div class="list-container" v-if="tableList.length">
            <div class="list-box" v-for="(item, index) in tableList" :key="index">
              <div class="item name name-right">{{ item.beRecommendedName }}</div>
              <div class="item mobile">{{ item.beRecommendedMobile }}</div>
              <div class="item status-img">
                <img v-if="item.recommendType == '1'" src="@/static/images/activityCenter/202404/02/status-01.png" />
                <img
                  v-if="item.beRecommendedWorkingState == '1' && item.beRecommendedIsSus != '1'"
                  src="@/static/images/activityCenter/202404/02/status-02.png"
                />
                <img v-if="item.beRecommendedIsSus == '1'" src="@/static/images/activityCenter/202404/02/status-03.png" />
                <img v-if="item.beRecommendedWorkingState == '0'" src="@/static/images/activityCenter/202404/02/status-04.png" />
              </div>
            </div>
            <div class="no-more" v-if="tableList.length">暂无更多</div>
          </div>
          <div class="no-data" v-else>
            <img class="title-pic" src="@/static/images/activityCenter/202404/02/29.png" />
            <span class="text">暂无数据</span>
          </div>
        </template>

        <template v-else-if="activeIndex == 3">
          <div class="table-head">
            <div class="item name name-right">姓名</div>
            <div class="item">手机号</div>
            <div class="item reward-detail">保单标保</div>
          </div>

          <div class="list-container" v-if="tableList.length">
            <div class="list-box" v-for="(item, index) in tableList" :key="index">
              <div class="item name name-right">{{ item.salesmanName }}</div>
              <div class="item">{{ item.beRecommendedMobile }}</div>
              <div class="item reward-detail">
                {{ item.foldFyb }}
              </div>
            </div>
            <div class="no-more" v-if="tableList.length">暂无更多</div>
          </div>
          <div class="no-data" v-else>
            <img class="title-pic" src="@/static/images/activityCenter/202404/02/29.png" />
            <span class="text">暂无数据</span>
          </div>
        </template>
      </div>
    </div>
    <div class="check-income" @click="viewIncomePage">
      <span>查看收入</span>
    </div>
  </div>
</template>

<script>
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  data() {
    return {
      activeIndex: 1,
      tabList: [
        {
          name: '好友注册奖',
          value: '1'
        },
        {
          name: '好友签约奖',
          value: '2'
        },
        {
          name: '好友签约开单奖',
          value: '3'
        }
      ],
      activityIds: [],
      tableList: [],
      statistics: {},
      downloadNum: '', //下载人数/签约人数
      rewardNum: '0' //奖励
    };
  },

  created() {
    const hideIndex = this.$route.query.hideIndex || '';
    this.tabList = this.tabList.filter(item => !hideIndex.includes(item.value));
    this.activityIds = this.$route.query.activityIds.split(',');
    this.getSigningList();
  },

  methods: {
    clickTabs(value) {
      this.tableList = [];
      this.activeIndex = value;
      if (value == 1) {
        this.getSigningList();
      } else if (value == 2) {
        this.getSigningList();
      } else if (value == 3) {
        this.getBillList();
      }
    },

    // 好友注册奖-好友签约
    getSigningList() {
      this.loading = true;
      this.$http({
        type: 'post',
        url: '/app/merchantActivity/queryGradientRecommendDetail',
        data: {
          activityId: this.activityIds[this.activeIndex == 1 ? 0 : 1]
        }
      }).then(res => {
        this.downloadNum = res.data.userNum || 0;
        this.rewardNum = res.data.reward || 0;
        this.tableList = res.data.beRecommendedList || [];
        this.loading = false;
      });
    },

    // 开单列表
    getBillList() {
      this.loading = true;
      this.$http({
        type: 'post',
        url: '/app/merchantActivity/queryPolicyListNew',
        data: {
          activityId: this.activityIds[2],
          allPolicy: 1,
          pageNum: 1,
          pageSize: 999
        }
      }).then(res => {
        this.tableList = res.data.data.records;
        this.statistics = res.data.statistics || {};
        this.loading = false;
      });
    },

    // 查看收入
    viewIncomePage() {
      this.$router.push({
        path: '/apps/settlement/okBao/incomeDetailPage1',
        query: {
          type: 2
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  background: url('~@/static/images/activityCenter/202404/02/27.png');
  background-size: 100% 100%;
  width: 750px;
  height: 100vh;
  background-repeat: no-repeat;
  position: relative;
  .top {
    padding: 57px 0 37px 0;
    display: flex;
    justify-content: center;
    .title-pic {
      width: 218px;
      height: 53px;
    }
  }
  .list-content {
    margin: 0 auto;
    width: 690px;
    height: 1100px;
    background: #fff;
    border-radius: 20px;
    .head-box {
      display: flex;
      .item {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 90px;
        flex: 1;
        color: #666666;
        font-size: 30px;
        position: relative;
        .line {
          position: absolute;
          width: 50px;
          height: 3px;
          background: #ed4013;
          bottom: 0;
        }
      }
      & .active {
        color: #333333;
        font-size: 32px;
        font-weight: bold;
      }
    }
    .statistics {
      padding: 0 30px;
      margin-bottom: 30px;
      .statistics-box {
        display: flex;
        justify-content: space-between;
        padding: 25px 0;
        background: #fff5e2;
        border-radius: 10px;
        .item {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          position: relative;
          flex: 1;
          .line {
            height: 70px;
            width: 1px;
            background: #e5d2b8;
            position: absolute;
            right: 0;
            top: 50%;
            margin-top: -35px;
          }
          .num {
            font-size: 38px;
            font-weight: bold;
            color: #ed4013;
            margin-bottom: 17px;
            .unit {
              font-size: 26px;
              font-weight: bold;
            }
          }
          .text {
            color: #7c4912;
            font-size: 26px;
          }
        }
      }
    }
    .list {
      padding: 0 30px;
    }
    .table-head-flex {
      height: 66px;
      background: #f5f5f5;
      display: flex;
      .item {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 26px;
        color: #888888;
      }
    }
    .table-head {
      height: 66px;
      background: #f5f5f5;
      display: flex;
      .item {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 26px;
        color: #888888;
      }
      .name {
        flex: 0.7;
        padding-left: 30px;
        justify-content: start;
      }
      .name-right {
        flex: 0.9;
      }
      .status {
        padding-left: 12px;
      }
      .status-img {
        flex: 0.8;
      }
      .mobile {
        flex: 1;
        margin-right: 60px;
      }
      .reward-detail {
        padding-right: 30px;
        justify-content: end;
      }
    }
    .list-container {
      overflow-y: auto;
      height: 750px;
      .list-box {
        height: 90px;
        border-bottom: 1px solid #f0f0f0;
        display: flex;
        .item {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #333333;
          font-size: 28px;
          img {
            width: 96px;
            height: 40px;
          }
          &.red {
            font-size: 28px;
            color: #ed4013;
            font-weight: bold;
          }
        }
        .name {
          flex: 0.7;
          padding-left: 30px;
          justify-content: start;
        }
        .name-right {
          flex: 0.9;
        }
        .status {
          padding-left: 12px;
        }
        .status-img {
          flex: 0.8;
        }
        .mobile {
          flex: 1;
          margin-right: 60px;
        }
        .reward-detail {
          padding-right: 35px;
          justify-content: end;
        }
      }
      .no-more {
        text-align: center;
        height: 90px;
        line-height: 90px;
        font-size: 26px;
        color: #bfbfbf;
      }
    }
    .no-data {
      height: 500px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      img {
        width: 360px;
        height: 200px;
      }
      .text {
        margin-top: 40px;
        font-size: 28px;
        color: #888888;
      }
    }
  }
  .check-income {
    position: absolute;
    bottom: 70px;
    left: 50%;
    margin-left: -349px;
    width: 698px;
    height: 98px;
    background: url('~static/images/activityCenter/202404/02/31.png') no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      font-size: 34px;
      color: #fff;
      letter-spacing: 0.8px;
    }
  }
}
</style>
